import { render, staticRenderFns } from "./ExamOptimizerOutputInputSettings.vue?vue&type=template&id=7033895d&"
import script from "./ExamOptimizerOutputInputSettings.vue?vue&type=script&lang=js&"
export * from "./ExamOptimizerOutputInputSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports